import { App } from './app.js';
import './styles/base.css';
import './styles/components.css';
document.addEventListener('DOMContentLoaded', function() { var app = new App(); app.init(); });
